import CardboardModeInstructions from "../../vue/components/cardboard-mode-instructions.component.vue";
import EnterVrButton from "../../vue/components/enter-vr-button.component.vue";
import Header from "../../vue/components/header.component.vue";
import Loader from "../../vue/components/loader.component.vue";
import { addVueComponent } from "../utils/vue.utils";
import { config } from "../../vue/helpers/domain-config";
import WhatsAppChat from "../../vue/components/whatsapp-chat.components.vue";
import { getDomainConfigValue } from "../../utils/domain-config";
import { getDomainTheme } from "../../vue/utils/domains-theme";
import zendeskButton from "../../vue/components/zendesk-button.component.vue";
import AppShortcutsDock from "../../vue/components/app-shortcuts-dock.component.vue";
// import ChatGpt from "../../vue/components/chatgpt.component.vue";
const theme = getDomainTheme(config.productName)[config.subdomain];

AFRAME.registerSystem("vue-ux", {
  whatsappUrl: theme ? theme.whatsappUrl : null,
  zendeskLineAccountURL: theme ? theme.zendeskLineAccountURL : null,
  init: function () {
    this.onSetScene = this.onSetScene.bind(this);
    this.el.sceneEl.addEventListener("setScene", this.onSetScene);
    setTimeout(() => {
      if (config.subdomain !== "holozonia") {
        addVueComponent(EnterVrButton, {}, document.querySelector("#vue-ui"));
        addVueComponent(Header, {}, document.querySelector("#vue-ui"));

        if (this.zendeskLineAccountURL) {
          addVueComponent(zendeskButton, {}, document.querySelector("#vue-ui"));
        }
        if (this.whatsappUrl) {
          addVueComponent(WhatsAppChat, {}, document.querySelector("#vue-ui"));
        }
      }
      addVueComponent(CardboardModeInstructions, {}, document.body);
      addVueComponent(Loader, {}, document.querySelector("#vue-ui"));
      // addVueComponent(ChatGpt, {}, document.querySelector("#vue-ui"));
      // if (getState().isMobile) {
      //   addVueComponent(MobileLandscapeInstructions, {}, document.body);
      // }
    }, 1000);
  },

  onSetScene: function (e) {
    this.el.sceneEl.removeEventListener("setScene", this.onSetScene);
    this.showVueElements(true);
  },

  showVueElements: function (animated) {
    const elHeader = document.querySelector("#vue-ui .header-component");
    const elWhatsapp = document.querySelector("#vue-ui .whatsapp-wrapper");
    const elZendeskButton = document.querySelector("#vue-ui .zendesk-wrapper");
    // const elChatGpt = document.querySelector("#vue-ui .chatgpt-component");
    if (!elHeader) {
      setTimeout(() => this.showVueElements());
      return;
    }

    if (config.subdomain !== "holozonia") {
      if (animated) {
        elHeader.classList.add("animated");
        if (elWhatsapp) {
          elWhatsapp.classList.add("animated");
        }
        if (elZendeskButton) {
          elZendeskButton.classList.add("animated");
        }
      }
      elHeader.classList.add("visible");
      if (elWhatsapp) {
        elWhatsapp.classList.add("visible");
      }
      if (elZendeskButton) {
        elZendeskButton.classList.add("visible");
      }
    }
  },
});
